import { Link } from 'react-router-dom';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import styles from './GalleryPage.module.css';

export function GalleryPage() {
  useDocumentTitle('Gallery');

  return (
    <div className="container">
      <header className={styles.pageHeader}>
        <h1 className={styles.title}>Gallery</h1>
        <p className={styles.lede}>
          Our project photos are on the way. In the meantime, get in touch and we'll walk
          you through past builds directly — floor plans, finishes, and all.
        </p>
        <Link to="/contact" className={`btn btn-primary ${styles.cta}`}>
          Ask to see our work
        </Link>
      </header>
    </div>
  );
}
